
import {isLocalStorageSupport} from './util'
const isSupport = isLocalStorageSupport()
const userInfoKey = 'gdrunshi.zikao.consultInfo'
function removeItem (key) {
  if (isSupport) {
    window.localStorage.removeItem(key)
  } else {
    Cookies.remove(key)
  }
}
function getItem (key, isJSON) {
  var data
  if (isSupport) {
    data = window.localStorage.getItem(key)
  } else {
    data = Cookies.get(key)
  }
  try {
    data = JSON.parse(data)
    if (Date.now() - data.timestamp > 1000 * 60 * 60 * 24) {
      removeItem(key)
      return null
    } else if (data.isJSON) {
      return JSON.parse(data.val)
    } else {
      return data.val
    }
  } catch (e) {
    removeItem(key)
    return null
  }
}

function setItem (key, val) {
  if (isSupport) {
    let data = {
      timestamp: Date.now(),
      val
    }
    window.localStorage.setItem(key, JSON.stringify(data))
  } else {
    Cookies.set(key, JSON.stringify(val), {
      expires: 1,
      path: '/'
    })
  }
}

export function setUserInfo (userInfo) {
  setItem(userInfoKey, userInfo)
}

export function getToken () {
  const userInfo = getItem(userInfoKey, true)
  return userInfo ? userInfo.token : ''
}

export function getUserInfo () {
  return getItem(userInfoKey, true)
}

export function removeUserInfo () {
  removeItem(userInfoKey)
}



// WEBPACK FOOTER //
// ./src/utils/user-info.js